export default function MoreGallery({ className }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" className={className}>
      <path
        fill="#0F0F10"
        fillRule="evenodd"
        d="M3.2 2.398a1.6 1.6 0 0 0-1.6 1.6v8a1.6 1.6 0 0 0 1.6 1.6h9.6a1.6 1.6 0 0 0 1.6-1.6v-8a1.6 1.6 0 0 0-1.6-1.6H3.2Zm9.6 9.6H3.2l3.2-6.4 2.4 4.8 1.6-3.2 2.4 4.8Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
